module.exports = __webpack_public_path__ + "media/components/country-flag/static/es-4278204e708d8463107b0f25b4f29a10.svg";